var _defs, _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForteslogoRegBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 449.3 181.33",
    style: {
      enableBackground: "new 0 0 449.3 181.33"
    },
    xml_space: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlns_svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs65"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.st0{fill:#FF1449;}\n\t.st1{fill:#6CED48;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#00CFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.83,90.39c-11.85,0-21.5-9.64-21.5-21.5c0-11.85,9.64-21.5,21.5-21.5c11.85,0,21.5,9.64,21.5,21.5   C145.33,80.74,135.68,90.39,123.83,90.39z M123.83,57.49c-6.28,0-11.4,5.11-11.4,11.4c0,6.29,5.11,11.4,11.4,11.4   c6.28,0,11.4-5.11,11.4-11.4C135.23,62.6,130.12,57.49,123.83,57.49z",
    id: "path4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.71,63.9c-2.25,0-4.3-1.51-4.89-3.79c-3.19-12.39-12.87-22.05-25.26-25.22c-2.7-0.69-4.33-3.44-3.64-6.14   c0.69-2.7,3.44-4.33,6.14-3.64c15.96,4.09,28.43,16.54,32.54,32.49c0.69,2.7-0.93,5.45-3.63,6.15   C163.55,63.85,163.12,63.9,162.71,63.9z",
    id: "path8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g14",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M123.83,114.08c-24.92,0-45.19-20.27-45.19-45.19c0-20.63,13.94-38.63,33.9-43.77   c2.69-0.69,5.45,0.93,6.15,3.63c0.69,2.7-0.93,5.45-3.63,6.15c-15.5,3.99-26.32,17.96-26.32,33.99c0,19.35,15.74,35.09,35.1,35.09   c16.05,0,30.03-10.84,34-26.36c0.69-2.7,3.43-4.33,6.14-3.64c2.7,0.69,4.33,3.44,3.64,6.14   C162.5,100.12,144.5,114.08,123.83,114.08z",
    id: "path12",
    style: {
      fill: "#000000"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.84,137.77c-34.12,0-62.74-24.42-68.05-58.07c-0.43-2.75,1.45-5.34,4.2-5.77c2.77-0.44,5.34,1.45,5.77,4.2   c4.53,28.71,28.95,49.55,58.07,49.55c29.12,0,53.54-20.84,58.06-49.55c0.44-2.76,3.03-4.63,5.77-4.2c2.76,0.43,4.64,3.02,4.2,5.77   C186.57,113.35,157.95,137.77,123.84,137.77z",
    id: "path16"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.78,63.91c-0.26,0-0.53-0.02-0.79-0.06c-2.76-0.43-4.63-3.02-4.2-5.77C61.1,24.42,89.72,0,123.84,0   c34.11,0,62.72,24.42,68.04,58.06c0.44,2.76-1.44,5.34-4.2,5.77c-2.75,0.43-5.34-1.44-5.77-4.2   c-4.53-28.71-28.95-49.54-58.06-49.54c-29.12,0-53.54,20.84-58.07,49.55C65.37,62.13,63.23,63.91,60.78,63.91z",
    id: "path20",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.13,156.71v24.26H0v-24.26H3.13z",
    id: "path24",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.1,180.97v-24.26h3.42l7.77,12.27c1.8,2.84,3.2,5.4,4.36,7.88l0.07-0.04c-0.29-3.24-0.36-6.19-0.36-9.97   v-10.15h2.95v24.26h-3.17l-7.7-12.31c-1.69-2.7-3.31-5.47-4.54-8.1l-0.11,0.04c0.18,3.06,0.25,5.97,0.25,10.01v10.37H31.1z",
    id: "path26",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.9,159.37h-7.38v-2.66h17.96v2.66h-7.42v21.6H81.9V159.37z",
    id: "path28",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.25,169.59h-9.43v8.75h10.51v2.63h-13.64v-24.26h13.1v2.63h-9.97V167h9.43V169.59z",
    id: "path30",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M157.9,157.03c1.58-0.32,3.85-0.5,6.01-0.5c3.35,0,5.51,0.61,7.02,1.98c1.22,1.08,1.91,2.74,1.91,4.61   c0,3.2-2.02,5.33-4.57,6.19v0.11c1.87,0.65,2.99,2.38,3.56,4.9c0.79,3.38,1.37,5.72,1.87,6.66h-3.24c-0.4-0.68-0.94-2.77-1.62-5.79   c-0.72-3.35-2.02-4.61-4.86-4.72h-2.95v10.51h-3.13V157.03z M161.03,168.08h3.2c3.35,0,5.47-1.83,5.47-4.61   c0-3.13-2.27-4.5-5.58-4.54c-1.51,0-2.59,0.14-3.09,0.29V168.08z",
    id: "path32",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.87,173.34l-2.52,7.63h-3.24l8.24-24.26h3.78l8.28,24.26h-3.35l-2.59-7.63H203.87z M211.82,170.89   l-2.38-6.98c-0.54-1.58-0.9-3.02-1.26-4.43h-0.07c-0.36,1.44-0.76,2.92-1.22,4.39l-2.38,7.02H211.82z",
    id: "path34",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.89,180.18c-1.15,0.58-3.46,1.15-6.41,1.15c-6.84,0-11.99-4.32-11.99-12.27c0-7.6,5.15-12.74,12.67-12.74   c3.02,0,4.93,0.65,5.76,1.08l-0.76,2.56c-1.19-0.58-2.88-1.01-4.9-1.01c-5.69,0-9.47,3.64-9.47,10.01c0,5.94,3.42,9.75,9.32,9.75   c1.91,0,3.85-0.4,5.11-1.01L260.89,180.18z",
    id: "path36",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.93,159.37h-7.38v-2.66h17.96v2.66h-7.42v21.6h-3.17V159.37z",
    id: "path38",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.85,156.71v24.26h-3.13v-24.26H331.85z",
    id: "path40",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.15,180.97l-7.92-24.26h3.38l3.78,11.95c1.04,3.28,1.94,6.23,2.59,9.07h0.07   c0.68-2.81,1.69-5.87,2.77-9.04l4.1-11.99h3.35l-8.67,24.26H365.15z",
    id: "path42",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.97,169.59h-9.43v8.75h10.51v2.63H402.4v-24.26h13.1v2.63h-9.97V167h9.43V169.59z",
    id: "path44",
    style: {
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.02,38.4c1.39,0,2.58,0.5,3.57,1.49c0.96,0.99,1.44,2.18,1.44,3.57c0,1.39-0.5,2.56-1.49,3.52  c-0.96,0.99-2.14,1.49-3.52,1.49h-0.04H10.33v15.41h18.51c1.39,0,2.58,0.48,3.57,1.44c0.99,0.99,1.49,2.18,1.49,3.57  s-0.5,2.58-1.49,3.57c-0.99,0.96-2.18,1.44-3.57,1.44H10.33v20.47c0,1.39-0.5,2.56-1.49,3.52c-0.99,0.99-2.18,1.49-3.57,1.49  c-1.39,0-2.56-0.5-3.52-1.49c-0.99-0.96-1.49-2.14-1.49-3.52V43.45c0-1.41,0.5-2.6,1.49-3.57c0.96-0.99,2.14-1.49,3.52-1.49h0.04  H36.02z",
    id: "path48",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.42,56.11c0,3.74-1.16,7.12-3.48,10.15c-2.24,3-5.18,5.14-8.83,6.41l9.64,19.53  c0.59,1.22,0.66,2.48,0.21,3.78c-0.42,1.3-1.26,2.26-2.5,2.89c-0.71,0.34-1.44,0.51-2.21,0.51c-2.07,0-3.56-0.93-4.46-2.8  l-11.25-22.8h-8.62v20.25c0,1.36-0.5,2.53-1.49,3.53c-0.96,0.96-2.14,1.44-3.52,1.44c-1.36,0-2.53-0.48-3.52-1.44  c-0.96-0.99-1.44-2.17-1.44-3.53V43.41c0-1.39,0.48-2.56,1.44-3.52c0.99-0.99,2.17-1.49,3.52-1.49h17.58  c5.24,0,9.69,1.73,13.38,5.18C256.56,47.03,258.42,51.21,258.42,56.11z M239.82,63.79c2.38-0.08,4.42-0.86,6.11-2.34  c1.67-1.5,2.51-3.28,2.51-5.35c0-2.15-0.88-3.98-2.63-5.48c-1.76-1.5-3.86-2.17-6.33-2.17h-12.57v15.33H239.82z",
    id: "path50",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.21,48.46H275.6c-1.39,0-2.58-0.5-3.57-1.49c-0.96-0.96-1.44-2.18-1.44-3.57s0.48-2.56,1.44-3.52  c0.99-0.99,2.18-1.49,3.57-1.49h35.29c1.36,0,2.53,0.5,3.52,1.49c0.96,0.96,1.44,2.14,1.44,3.52s-0.48,2.6-1.44,3.57  c-0.99,0.99-2.17,1.49-3.52,1.49h-12.65v45.9c0,1.39-0.5,2.58-1.49,3.57c-0.96,0.96-2.14,1.44-3.52,1.44  c-1.39,0-2.56-0.48-3.52-1.44c-0.99-0.99-1.49-2.18-1.49-3.57V48.46z",
    id: "path52",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M367.03,89.31c1.39,0,2.56,0.5,3.52,1.49c0.99,0.99,1.49,2.18,1.49,3.57c0,1.39-0.5,2.56-1.49,3.52  c-0.96,0.99-2.14,1.49-3.52,1.49h-30.74c-1.39,0-2.56-0.5-3.52-1.49c-0.99-0.96-1.49-2.14-1.49-3.52V43.45c0-1.41,0.5-2.6,1.49-3.57  c0.96-0.99,2.14-1.49,3.52-1.49h0.04h30.7c1.39,0,2.58,0.5,3.57,1.49c0.96,0.99,1.44,2.18,1.44,3.57c0,1.39-0.5,2.56-1.49,3.52  c-0.96,0.99-2.14,1.49-3.52,1.49h-0.04h-25.65v15.41h18.51c1.39,0,2.58,0.48,3.57,1.44c0.99,0.99,1.49,2.18,1.49,3.57  s-0.5,2.58-1.49,3.57c-0.99,0.96-2.18,1.44-3.57,1.44h-18.51v15.41H367.03z",
    id: "path54",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M428.33,82.37c-0.23,5.07-2.25,9.36-6.07,12.87c-3.85,3.51-8.44,5.27-13.76,5.27c-4.61,0-8.75-0.99-12.4-2.97  c-4.39-2.38-7.18-5.83-8.37-10.36c-0.34-1.33-0.17-2.59,0.51-3.78c0.71-1.19,1.73-1.95,3.06-2.29c1.33-0.34,2.59-0.17,3.78,0.51  c1.19,0.71,1.95,1.73,2.29,3.06c0.51,1.9,1.9,3.38,4.16,4.46c2.04,0.93,4.36,1.4,6.96,1.4c2.66,0,4.94-0.83,6.84-2.5  c1.92-1.64,2.94-3.68,3.06-6.12c0.06-1.47-0.53-3.91-1.64-5.07c-1.76-1.87-4.7-2.83-8.83-2.89h-0.04c-0.11,0-0.14,0-0.08,0  c-0.03,0-0.06,0-0.08,0c-6.94-0.11-12.24-2.11-15.92-5.99c-3.03-3.23-4.44-7.75-4.25-12.03c0.23-5.1,2.25-9.88,6.07-13.39  c3.82-3.51,8.41-5.27,13.76-5.27c4.61,0,8.75,0.99,12.4,2.97c4.38,2.38,7.18,5.83,8.37,10.36c0.34,1.33,0.15,2.59-0.55,3.78  c-0.68,1.19-1.69,1.95-3.01,2.29c-1.33,0.34-2.59,0.17-3.78-0.51c-1.19-0.71-1.95-1.73-2.29-3.06c-0.51-1.9-1.91-3.38-4.2-4.46  c-2.01-0.93-4.32-1.4-6.92-1.4c-2.66,0-4.95,0.83-6.88,2.51c-1.9,1.67-2.9,4.19-3.01,6.6c-0.06,1.47,0.47,3.58,1.57,4.77  c1.76,1.84,4.7,2.79,8.83,2.84h0.21c6.94,0.11,12.24,2.12,15.92,6.03C427.05,73.19,428.53,78.07,428.33,82.37z",
    id: "path56",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g60",
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M449.3,43.92c0,3.3-2.59,5.88-5.95,5.88c-3.33,0-5.99-2.59-5.99-5.88c0-3.22,2.66-5.81,5.99-5.81   C446.71,38.1,449.3,40.69,449.3,43.92z M438.85,43.92c0,2.59,1.91,4.64,4.54,4.64c2.55,0,4.43-2.06,4.43-4.61   c0-2.59-1.88-4.68-4.46-4.68S438.85,41.36,438.85,43.92z M442.42,46.96h-1.35v-5.81c0.53-0.11,1.28-0.18,2.23-0.18   c1.1,0,1.59,0.18,2.02,0.43c0.32,0.25,0.57,0.71,0.57,1.28c0,0.64-0.5,1.13-1.2,1.35v0.07c0.57,0.21,0.89,0.64,1.06,1.42   c0.18,0.89,0.28,1.24,0.43,1.45h-1.45c-0.18-0.21-0.28-0.74-0.46-1.42c-0.11-0.64-0.46-0.92-1.2-0.92h-0.64V46.96z M442.46,43.67   h0.64c0.74,0,1.35-0.25,1.35-0.85c0-0.53-0.39-0.89-1.24-0.89c-0.35,0-0.6,0.04-0.74,0.07V43.67z",
    id: "path58",
    style: {
      fill: "#000000"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForteslogoRegBlack);
export default __webpack_public_path__ + "static/media/Forteslogo_REG_black.6d06b8eac200ae4397ed4a80c1e6ffdf.svg";
export { ForwardRef as ReactComponent };